import type { FetchResponse } from '@sydle/ui-api';
import { BufferedRequests } from './buffered-requests';

export type Options<ArgsType = any> = {
  mergeArgs: (oldArgs: ArgsType, newArgs: ArgsType) => any;
  debounceTime: number;
  splitResponse?: (args: ArgsType, response: any) => any;
};

export const bufferedRequests = new BufferedRequests();

export async function doBufferedRequest(identifier: string, args: any, requestFn: (args: any) => any, { mergeArgs, debounceTime, splitResponse }: Options): Promise<FetchResponse> {
  bufferedRequests.tryAddBuffer(identifier);
  bufferedRequests.setMergedArgs(identifier, args, mergeArgs);
  bufferedRequests.clearTimeout(identifier);
  bufferedRequests.setExtraAttribute(identifier, 'request', requestFn);

  const promise = new Promise<FetchResponse>(resolve => {
    bufferedRequests.addSubscriber(identifier, { resolve, params: args });

    const timeoutId = setTimeout(async () => {
      const args = bufferedRequests.getArgs(identifier);
      bufferedRequests.clearArgs(identifier);
      const subscribers = bufferedRequests.getSubscribers(identifier);
      const response = requestFn(args);
      bufferedRequests.resolveSubscribers(subscribers, response, splitResponse);
      bufferedRequests.clearSubscribers(identifier);
    }, debounceTime);

    bufferedRequests.setTimeoutId(identifier, Number(timeoutId));
  });

  return promise;
}

export async function flushBufferedRequest(identifier: string, requestFn?: any, splitResponse?: any): Promise<any> {
  if (!bufferedRequests.hasBuffer(identifier)) {
    return;
  }

  bufferedRequests.clearTimeout(identifier);
  const request = requestFn || bufferedRequests.getExtraAttribute(identifier, 'request');
  const response = await request(bufferedRequests.getArgs(identifier));
  bufferedRequests.resolveSubscribers(bufferedRequests.getSubscribers(identifier), response, splitResponse);
  bufferedRequests.removeBuffer(identifier);
}
